import { exists } from '@/api'
import { BibliographyFullId, Prefix } from '@/types'

export interface BibliographySearchResultContentItem {
  id: string
  bibliographyFullId: BibliographyFullId
  prefix: Prefix
  bibliographyId: number
  bibliographyContentId: number
  contentDisplayTitle: string
  contentDisplayAuthor: string
  contentSortTitle: string
  contentSortNumber: string
  contentSortKana: string
  contentSortAuthor: string
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  displayPublished: string
  sortTitle: string
  sortNumber: string
  sortKana: string
  sortAuthor: string
  sortPublisher: string
  sortPublished: number
  _fetched: boolean
  // TODO RecycleScrollerのkeyにidを指定すると挙動がおかしくなるため追加。後で調査。 by nagasu
  _index: number
}

export function BibliographySearchResultContentItemFromJSON(
  json: any,
  index: number
): BibliographySearchResultContentItem {
  return {
    id: json.prefix + json.bibliography_id,
    bibliographyFullId: {
      prefix: json.prefix,
      id: json.bibliography_id
    },
    prefix: json.prefix,
    bibliographyId: json.bibliography_id,
    bibliographyContentId: json.bibliography_content_id,
    contentDisplayTitle: exists(json, 'content_display_title')
      ? json.content_display_title
      : '',
    contentDisplayAuthor: exists(json, 'content_display_author')
      ? json.content_display_author
      : '',
    contentSortTitle: exists(json, 'content_sort_title')
      ? json.content_sort_title
      : '',
    contentSortNumber: exists(json, 'content_sort_number')
      ? json.content_sort_number
      : '',
    contentSortKana: exists(json, 'content_sort_kana')
      ? json.content_sort_kana
      : '',
    contentSortAuthor: exists(json, 'content_sort_author')
      ? json.content_sort_author
      : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : '',
    sortTitle: exists(json, 'sort_title') ? json.sort_title : '',
    sortNumber: exists(json, 'sort_number') ? json.sort_number : '',
    sortKana: exists(json, 'sort_kana') ? json.sort_kana : '',
    sortAuthor: exists(json, 'sort_author') ? json.sort_author : '',
    sortPublisher: exists(json, 'sort_publisher') ? json.sort_publisher : '',
    sortPublished: exists(json, 'sort_published') ? json.sort_published : 0,
    _fetched: false,
    _index: index
  }
}
